export default __webpack_public_path__ + "static/media/group15158-irqi.0a8972f7.svg";